<form [formGroup]="form">

  @if (single) {
    <app-input-group>
      <label appLabel>{{ 'dashboard.timeseries.missing.meteringpointid' | translate }}</label>
      <input appInput type="text" formControlName="meteringPointIdentification" readonly>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'dashboard.timeseries.missing.dateofwork' | translate }}</label>
      <input appInput type="text" formControlName="dayOfWork" readonly>
    </app-input-group>
  } @else {
    <p class="mb-4 text-sm text-gray-600">
      {{ 'dashboard.timeseries.missing.commentMultiple' | translate: { count: selectedCount } }}
    </p>
  }

  <app-input-group>
    <label appLabel>{{ 'dashboard.timeseries.missing.comment' | translate }}</label>
    <textarea appInput formControlName="comment" rows="4" [maxlength]="maxLength"></textarea>
  </app-input-group>

  <p class="-mt-2 text-right text-xs text-gray-500">{{ commentLength }} / {{ maxLength }}</p>

</form>
